module.exports = __webpack_public_path__ + "img/agree.de6519c5.png";